module.exports = __webpack_public_path__ + "img/startBattery_offline.0bcd068e.png";